import React, { useContext } from "react"; // eslint-disable-line
import ValidationContext from "./validation";

export default function Error({ name, error }) {
  let validation = useContext(ValidationContext);
  if (name)
    error =
      error ||
      (validation && validation.show && validation.getDisplayError(name));

  if (!error) return null;
  return (
    <span className="error-msg" role="alert" aria-live="polite">
      <i className="fas fa-exclamation-circle" aria-hidden="true"></i>
      <span>{error}</span>
    </span>
  );
}
